/** This will always include the trailing slash */
export const PAGE_BASE = process.env.PUBLIC_URL
export const API_BASE = `${PAGE_BASE}api`
